// Where to go after signing in: the page someone was sent to sign in from (e.g. the connector's Allow page, which an
// AI app opened), kept in this tab only. A Google or GitHub sign-in comes back to the same tab, so it survives that too.
const KEY = "cb_return_to";

export function rememberReturn(path) {
  try { sessionStorage.setItem(KEY, path); } catch { /* private window: back to the home page */ }
}

// the remembered page, once, if it is a page of this app; otherwise `fallback`
export function takeReturn(fallback) {
  let path = null;
  try {
    path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch { /* nothing remembered */ }
  return path && path.startsWith("/") && !path.startsWith("//") && !path.startsWith("/login") ? path : fallback;
}
